'use strict';

/**
 * Defines static variables corresponding to the various formatting possibilities
 */

module.exports = {
  SUBSCRIPT: 'subscript',
  SUPERSCRIPT: 'superscript',
  SUPERIMPOSE: 'superimpose',
  TEXT: 'text'
};
